import api from "./instance";

export const getProfile = () => api.get("/staff/getprofile");

export const getStaffProfile = () => api.get("/staff/staffprofile");

export const editProfile = (_staffId, payload) =>
  api.put("/staff/editprofile", payload);

export const updateProfileImage = (_staffId, formData) =>
  api.put("/staff/updateProfileImage", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const getWallet = () => api.get("/staff/wallet");

export const uploadUserFile = (_staffId, formData) =>
  api.put("/staff/userupload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const getSteps = () => api.get("/staff/steps");

/** Whole number from 1 to 100,000. Throws before the request if invalid. */
export const addSteps = (steps) => {
  const n = Number(steps);
  if (!Number.isInteger(n) || n < 1 || n > 100000) {
    throw new Error("Steps must be a whole number from 1 to 100,000.");
  }
  return api.post("/staff/addsteps", { steps: n });
};

export const redeemCoins = () => api.post("/staff/redeemcoins");
